const light = {
  color: "white",
  bgcolor: "black",
  bgImage: "linear-gradient(180deg,skyblue 24%,lightpink 70%)",
};

const dark = {
  color: "black",
  bgcolor: "white",
  bgImage: "linear-gradient(180deg,#555555 20%,#303230 70%)",
};

const themes = {
  light: light,
  dark: dark,
};

export default themes;
